import { Routes, Route } from "react-router-dom";
import HomeV1 from "../pages/homeV1";
import HomeV2 from "../pages/homeV2";
import HomeV3 from "../pages/homeV3";
import Blogs from "../pages/blogs";
import BlogDetails from "../pages/blogDetails";
import ComingSoon from "../pages/ComingSoon";
import Mint from "../pages/Mint";
import NotFound from "../pages/NotFound";

function App() {
  return (
    <Routes>
      {/* <Route path="/home-one" element={<HomeV1 />} exact /> */}
      <Route path="/" element={<HomeV2 />} />
      {/* <Route path="/mint" element={<ComingSoon />} /> */}
      {/* <Route path="/home-three" element={<HomeV3 />} /> */}
      {/* <Route path="/blogs" element={<Blogs />} /> */}
    {/* <Route path="/post" element={<BlogDetails />} /> */}
     <Route path="/mint" element={<Mint />} />
    <Route path="/*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
